export default {"src":"/_next/static/image/public/assets/icons/edit.0c27823ae3ef08094e9c0ebf4c847d2b.svg","height":20,"width":20};